// extracted by mini-css-extract-plugin
export default {"footer-wrap":"_8PBmhrJwzc0VueDx4uh1wQ=="};